<template>
    <div>
        <div><van-icon name="arrow-left" class="icon_o"/></div>
        <div><van-icon name="plus" class="icon_t"/></div>
        <van-tabs v-model="active">
            <van-tab title="我的资源">
                <div class="list">
                    
                </div>
            </van-tab>
            <van-tab title="校本资源">
                <div class="list">
                    
                </div>
            </van-tab>
            <van-tab title="云资源">
                <div class="list">
                    
                </div>
            </van-tab>
        </van-tabs>
        <div>
          <input type="text"  placeholder="搜索" >
        </div>
        <folder></folder>
    </div>
</template>

<script>
import folder from '../../components/folder'
import Vue from 'vue';
import { Tab, Tabs } from 'vant';
import { Icon } from 'vant';

Vue.use(Icon)
Vue.use(Tab);
Vue.use(Tabs);
export default {
    components:{
      folder
    },
    data(){
      return {
          active: 0
      };
    },
    methods: {

    }
}
</script>

<style scoped>
.icon_o{
    position: absolute;
    top: 15px;
    left: 16px;
}
.icon_t{
    position: absolute;
    top: 15px;
    right: 16px;
}
.van-tabs /deep/ .van-tabs__wrap {
  height: 36px;
  margin: 0 70px;
  background-color: #fff;
}
.van-tabs /deep/ .van-tabs__line {
  background-color: #3296fa;
  height: 2px;
}
.list{
    padding-top: 15px;
}
input{
  width: 345px;
  margin: 10px 15px;
  border: none;
  line-height: 32px;
  text-align: center;
  background-color: #eee;
  border-radius: 16px;
}
</style>


// WEBPACK FOOTER //
// src/pages/resource/resource.vue